import {
  FETCH_AGENT_TRAINING_REQUEST,
  FETCH_AGENT_TRAINING_SUCCESS,
  FETCH_AGENT_TRAINING_FAILURE,

  CREATE_AGENT_TRAINING_REQUEST,
  CREATE_AGENT_TRAINING_SUCCESS,
  CREATE_AGENT_TRAINING_FAILURE,

  UPDATE_AGENT_TRAINING_REQUEST,
  UPDATE_AGENT_TRAINING_SUCCESS,
  UPDATE_AGENT_TRAINING_FAILURE,

  DELETE_AGENT_TRAINING_REQUEST,
  DELETE_AGENT_TRAINING_SUCCESS,
  DELETE_AGENT_TRAINING_FAILURE,
} from "./types";

import {
  fetchAgentTraining,
  createAgentTraining,
  updateAgentTraining,
  deleteAgentTraining,
} from "../../services/agentTrainingService";



export const fetchAgentTrainingRequest = () => ({
  type: FETCH_AGENT_TRAINING_REQUEST,
});

export const fetchAgentTrainingSuccess = (
  trainingData
) => ({
  type: FETCH_AGENT_TRAINING_SUCCESS,
  payload: trainingData,
});

export const fetchAgentTrainingFailure = (
  error
) => ({
  type: FETCH_AGENT_TRAINING_FAILURE,
  payload: error,
});



export const createAgentTrainingRequest = () => ({
  type: CREATE_AGENT_TRAINING_REQUEST,
});

export const createAgentTrainingSuccess = (
  training
) => ({
  type: CREATE_AGENT_TRAINING_SUCCESS,
  payload: training,
});

export const createAgentTrainingFailure = (
  error
) => ({
  type: CREATE_AGENT_TRAINING_FAILURE,
  payload: error,
});



export const updateAgentTrainingRequest = () => ({
  type: UPDATE_AGENT_TRAINING_REQUEST,
});

export const updateAgentTrainingSuccess = (
  training
) => ({
  type: UPDATE_AGENT_TRAINING_SUCCESS,
  payload: training,
});

export const updateAgentTrainingFailure = (
  error
) => ({
  type: UPDATE_AGENT_TRAINING_FAILURE,
  payload: error,
});


export const deleteAgentTrainingRequest = () => ({
  type: DELETE_AGENT_TRAINING_REQUEST,
});

export const deleteAgentTrainingSuccess = (
  trainingId
) => ({
  type: DELETE_AGENT_TRAINING_SUCCESS,
  payload: trainingId,
});

export const deleteAgentTrainingFailure = (
  error
) => ({
  type: DELETE_AGENT_TRAINING_FAILURE,
  payload: error,
});



// Fetch Agent Training
export const fetchAgentTrainingAction =
  (
    page = 1,
    size = 10
  ) =>
  async (dispatch) => {

    dispatch(
      fetchAgentTrainingRequest()
    );

    try {

      const response =
        await fetchAgentTraining(
          page,
          size
        );

      if (response.success) {

        dispatch(
          fetchAgentTrainingSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      } else {

        dispatch(
          fetchAgentTrainingFailure(
            response.error
          )
        );

        return {
          success: false,
          error: response.error,
        };
      }

    } catch (error) {

      const message =
        error.message ||
        "Failed to fetch Agent Training";

      dispatch(
        fetchAgentTrainingFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };


// Create Agent Training
export const createAgentTrainingAction =
  (payload) =>
  async (dispatch) => {

    dispatch(
      createAgentTrainingRequest()
    );

    try {

      const response =
        await createAgentTraining(
          payload
        );

      if (response.success) {

        dispatch(
          createAgentTrainingSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      } else {

        dispatch(
          createAgentTrainingFailure(
            response.error
          )
        );

        return {
          success: false,
          error: response.error,
        };
      }

    } catch (error) {

      const message =
        error.message ||
        "Failed to create Agent Training";

      dispatch(
        createAgentTrainingFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };


// Update Agent Training
export const updateAgentTrainingAction =
  (
    trainingId,
    payload
  ) =>
  async (dispatch) => {

    dispatch(
      updateAgentTrainingRequest()
    );

    try {

      const response =
        await updateAgentTraining(
          trainingId,
          payload
        );

      if (response.success) {

        dispatch(
          updateAgentTrainingSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      } else {

        dispatch(
          updateAgentTrainingFailure(
            response.error
          )
        );

        return {
          success: false,
          error: response.error,
        };
      }

    } catch (error) {

      const message =
        error.message ||
        "Failed to update Agent Training";

      dispatch(
        updateAgentTrainingFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };


// Delete Agent Training
export const deleteAgentTrainingAction =
  (trainingId) =>
  async (dispatch) => {

    dispatch(
      deleteAgentTrainingRequest()
    );

    try {

      const response =
        await deleteAgentTraining(
          trainingId
        );

      if (response.success) {

        dispatch(
          deleteAgentTrainingSuccess(
            trainingId
          )
        );

        return {
          success: true,
          message: response.message,
        };

      } else {

        dispatch(
          deleteAgentTrainingFailure(
            response.error
          )
        );

        return {
          success: false,
          error: response.error,
        };
      }

    } catch (error) {

      const message =
        error.message ||
        "Failed to delete Agent Training";

      dispatch(
        deleteAgentTrainingFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };